(() => {
  const previewPrefix = 'TheCupLab Vorschau ';
  const setPrefix = 'TheCupLab Set ';
  const personalizationPrefix = 'TheCupLab Personalisierung ';
  // Sets only carry Motivaufteilung visibly (all motifs are in _CupSet), single cups the fields below.
  const personalizationKeys = ['Motivaufteilung', 'Datei', 'Text', 'Bildbeschreibung', 'Hashtags', 'Songtitel', 'Interpret', 'Social-Media-Stil', 'Sticker-Hintergrundfarbe', 'Bildrechte und Personalisierung bestätigt', '_Quelldatei', '_Druckvorlage'];
  let pendingSync;

  function isPreviewUrl(value) {
    try {
      const url = new URL(value);
      return url.protocol === 'https:' && url.hostname === 'cdn.shopify.com' && /\.(png|jpe?g|webp)$/i.test(url.pathname);
    } catch {
      return false;
    }
  }

  async function sync() {
    const cartUrl = window.routes?.cart_url || '/cart';
    const updateUrl = window.routes?.cart_update_url || `${cartUrl}/update`;
    const cartResponse = await fetch(`${cartUrl}.js`, {credentials: 'same-origin', cache: 'no-store'});
    if (!cartResponse.ok) throw new Error('Warenkorb konnte nicht geladen werden');
    let cart = await cartResponse.json();
    // A set whose staged upload never finished must not reach checkout.
    const unfinished = (cart.items || []).filter((item) => item.properties?._UploadOffen);
    if (unfinished.length) throw Object.assign(new Error('Cup-Set unvollständig'), {unfinished});
    for (const item of cart.items || []) {
      if (item.properties?._cup_configurator !== 'true') continue;
      const properties = {...item.properties};
      let changed = false;
      for (const key of ['Größe', 'Anzahl Cups', 'Ausführung']) {
        if (!Object.prototype.hasOwnProperty.call(properties, key)) continue;
        properties[`_${key}`] = properties[`_${key}`] || properties[key];
        delete properties[key];
        changed = true;
      }
      if (!changed) continue;
      const response = await fetch(`${cartUrl}/change.js`, {
        method: 'POST', credentials: 'same-origin',
        headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
        body: JSON.stringify({id: item.key, quantity: item.quantity, properties}),
      });
      if (!response.ok) throw new Error('Cup-Angaben konnten nicht aktualisiert werden');
      cart = await response.json();
    }
    const attributes = {};
    Object.keys(cart.attributes || {}).forEach((key) => {
      if (key.startsWith(previewPrefix) || key.startsWith(setPrefix) || key.startsWith(personalizationPrefix)) attributes[key] = '';
    });

    let index = 0;
    const variantCounts = new Map();
    for (const item of cart.items || []) {
      if (item.properties?._cup_configurator === 'true') {
        const variantId = String(item.variant_id || item.id);
        const occurrence = (variantCounts.get(variantId) || 0) + 1;
        variantCounts.set(variantId, occurrence);
        attributes[`${personalizationPrefix}${variantId} Anzahl`] = String(occurrence);
        for (const key of personalizationKeys) {
          const value = item.properties[key];
          if (typeof value !== 'string' || !value.trim()) continue;
          if ((key === '_Quelldatei' || key === '_Druckvorlage') && !isPreviewUrl(value)) continue;
          attributes[`${personalizationPrefix}${variantId} ${occurrence} ${key}`] = value;
        }
      }
      const preview = item.properties?.['_Personalisierte Vorschau'];
      if (!isPreviewUrl(preview)) continue;
      index += 1;
      const count = parseInt(item.properties?.['_Anzahl Cups'] || item.properties?.['Anzahl Cups'], 10) || item.quantity;
      const execution = item.properties?.['_Ausführung'] || item.properties?.['Ausführung'] || '';
      const withLid = /mit deckel/i.test(execution);
      const cupName = item.product_title || item.title || 'personalisierte Cups';
      attributes[`${previewPrefix}${index}`] = preview;
      attributes[`${setPrefix}${index}`] = `${count}er-Set ${cupName}${withLid ? ' mit Deckel' : ' ohne Deckel'}`;
    }

    if (!Object.keys(attributes).length) return;
    const updateResponse = await fetch(`${updateUrl}.js`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
      body: JSON.stringify({attributes}),
    });
    if (!updateResponse.ok) throw new Error('Vorschau konnte nicht gespeichert werden');
  }

  window.theCupLabSyncPreviews = () => {
    if (!pendingSync) pendingSync = sync().finally(() => { pendingSync = null; });
    return pendingSync;
  };

  document.addEventListener('click', async (event) => {
    const button = event.target.closest?.('button[name="checkout"]');
    if (!button || button.dataset.cupPreviewSynced === 'true') return;
    // A required field (e.g. the AGB consent) is missing: let the browser show its hint right there.
    if (button.form && !button.form.checkValidity()) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    button.disabled = true;
    try {
      await window.theCupLabSyncPreviews();
      button.disabled = false;
      button.dataset.cupPreviewSynced = 'true';
      button.click();
      setTimeout(() => { delete button.dataset.cupPreviewSynced; }, 0);
    } catch (error) {
      button.disabled = false;
      if (error?.unfinished) {
        const remove = window.confirm('Ein Cup-Set wurde nicht vollständig übertragen und kann so nicht bestellt werden. Jetzt aus dem Warenkorb entfernen? Danach kannst du es einfach neu in den Warenkorb legen.');
        if (!remove) return;
        const cartUrl = window.routes?.cart_url || '/cart';
        try {
          for (const item of error.unfinished) {
            await fetch(`${cartUrl}/change.js`, {
              method: 'POST', credentials: 'same-origin',
              headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
              body: JSON.stringify({id: item.key, quantity: 0}),
            });
          }
        } finally {
          window.location.assign(cartUrl);
        }
        return;
      }
      window.alert('Die persönliche Cup-Vorschau konnte nicht gespeichert werden. Bitte versuche es erneut.');
    }
  }, true);
})();
